import { Card } from "theme-ui";
import * as React from 'react';
export default {
  Card,
  React
};